import { render, staticRenderFns } from "./InventarioPorPosicionesTicketComponent.vue?vue&type=template&id=fcbf2410&"
import script from "./InventarioPorPosicionesTicketComponent.vue?vue&type=script&lang=js&"
export * from "./InventarioPorPosicionesTicketComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports